import * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import { timeout, UserContext } from '../../../App'
import GridItem from '../../grid/GridItem'
import GridContainer from '../../grid/GridContainer'
import { makeStyles } from '@material-ui/core/styles'
import { AddAlert } from '@material-ui/icons'
import Snackbar from '../../snackbar/Snackbar'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { initialNotificationState } from '../../utils/state/ApplicationState'
import { DepartmentNewDeparture } from './DepartmentNewDeparture'
import { getApiUrl } from '../../../api/api'

const styles = {
  header: {
    padding: '15px 35px',
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
  },
}

const useStyles = makeStyles(styles)

export default function DepartmentNewDepartures({ departmentName }) {
  const classes = useStyles()

  const { user } = useContext(UserContext)

  const [notification, setNotification] = useState(initialNotificationState)

  const [proceeding, setProceeding] = useState(true)

  const [amounts, setAmounts] = useState([])

  const [departures, setDepartures] = useState([])

  // const options = {
  //   headers: { Authorization: `Bearer ${user.token}` },
  // }

  let department
  if (departmentName == null)
    department = user.authorities.filter(it => it.includes('DEPARTURE-H'))[0].split('-')[1].toLowerCase()
  else
    department = departmentName

  useEffect(() => {
    // const optionsConfirmed = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    //   params: { status: 'CONFIRMED' },
    // }
    getApiUrl({ status: 'CONFIRMED' })
      .get(`/api/departures/${department}`)
      .then(function(response) {
        setProceeding(false)
        const tmp = response.data.filter((departure) => departure.signature === undefined)
        setDepartures(tmp)
        setAmounts(new Array(tmp.length).fill('0'))
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [notification, department])

  const handleSignDeparture = (departureId, amount) => {
    setProceeding(true)
    getApiUrl()
      .post(
        `/api/departures/${department}`,
        {
          departureId: departureId,
          amount: amount,
        },
      )
      .then(function() {
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Unterschrieben',
          color: 'success',
        })
      })
      .catch(function(error) {
        setProceeding(false)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(() => {
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout)
      })
  }

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />

      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          {departures.length !== 0 ? (
            departures.map((row, index) => (
              <React.Fragment key={row.claimId}>
                <GridItem xs={12} sm={6} md={6} lg={4}>
                  <DepartmentNewDeparture
                    departure={row}
                    amounts={amounts}
                    index={index}
                    handleSignDeparture={handleSignDeparture}
                    setAmounts={setAmounts}
                  />
                </GridItem>
              </React.Fragment>
            ))
          ) : (
            <h4 className={classes.header}>Keine neue Auszüge</h4>
          )}
        </GridContainer>
      </GridItem>
    </GridContainer>
  )
}
